/**
 * Operator Website Configuration component.
 * Renders tabs (Images, Colors, Texts, Config) and receives state/callbacks from page.
 */

import React from "react";
import { Tabs } from 'antd';
import { BgColorsOutlined, FontSizeOutlined, SettingOutlined, PictureOutlined } from '@ant-design/icons';
import { OperatorWebsiteImagesTab } from './web-images.tab';
import { OperatorWebsiteColorsTab } from './web-colors.tab';
import { OperatorWebsiteTextsTab } from './web-texts.tab';
import { OperatorWebsiteSettingsTab } from './web-settings.tab';

const { TabPane } = Tabs;

export const OperatorWebsiteConfigComponent = (props) => {
    const {
        activeTab,
        onTabChange,
        websiteColors,
        websiteTexts,
        websiteConfig,
        onColorsChange,
        onTextsChange,
        onConfigChange,
        webConfigActions,
        onPreviewImageOverridesChange,
    } = props;

    return (
        <div className="operator-website-page-config">
            <div className="page-header">
                <h2 className="page-title">Operator Website Configuration</h2>
                <p className="page-description">
                    Configure images, colors, texts and settings for your customer-facing website.
                </p>
            </div>
            <Tabs
                activeKey={activeTab}
                onChange={onTabChange}
                className="config-tabs"
                size="large"
            >
                <TabPane
                    tab={
                        <span>
                            <PictureOutlined />
                            Images
                        </span>
                    }
                    key="images"
                >
                    <OperatorWebsiteImagesTab onPreviewImageOverridesChange={onPreviewImageOverridesChange} />
                </TabPane>

                <TabPane
                    tab={
                        <span>
                            <BgColorsOutlined />
                            Colors
                        </span>
                    }
                    key="colors"
                >
                    <OperatorWebsiteColorsTab
                        initialValues={websiteColors}
                        onValuesChange={onColorsChange}
                        active={activeTab === 'colors'}
                    />
                </TabPane>

                {/* <TabPane
                    tab={
                        <span>
                            <FontSizeOutlined />
                            Texts
                        </span>
                    }
                    key="texts"
                >
                    <OperatorWebsiteTextsTab
                        initialValues={websiteTexts}
                        onValuesChange={onTextsChange}
                        active={activeTab === 'texts'}
                    />
                </TabPane> */}

                <TabPane
                    tab={
                        <span>
                            <SettingOutlined />
                            Config
                        </span>
                    }
                    key="config"
                >
                    <OperatorWebsiteSettingsTab
                        initialValues={websiteConfig}
                        webConfigActions={webConfigActions}
                        onValuesChange={onConfigChange}
                        active={activeTab === 'config'}
                    />
                </TabPane>
            </Tabs>
        </div>
    );
};
